import { render, staticRenderFns } from "./parcelcode-edit.vue?vue&type=template&id=ab515b76"
import script from "./parcelcode-edit.vue?vue&type=script&lang=js"
export * from "./parcelcode-edit.vue?vue&type=script&lang=js"
import style0 from "./parcelcode-edit.vue?vue&type=style&index=0&id=ab515b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports